import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';

import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { ComponentsModule } from './page/components.module';
import { AppComponent } from './app.component';

import { LocalStorage } from './utils/LocalStorage';
import { SessionStorage } from './utils/SessionStorage';
import { CusRouteReuseStrategy } from './utils/CusRouteReuseStrategy';
import { ReuseStrategyTab } from './utils/ReuseStrategyTab';
import { DefaultInterceptor } from './utils/DefaultInterceptor';
import { HttpHelpUtils } from './utils/HttpHelpUtils';
import { HttpHelpUtilsWater } from "./utils/HttpHelpUtilsWater";
import { AppInitService } from './app-init.service';
//启动阶段通过 AppInitService（src/app/app-init.service.ts）比对本地 appVersion。
//若检测到新版本，自动清理可能影响显示/逻辑的本地存储键，仅保留白名单（例如 environment.tokenKey 登录态）。
export function initApp(appInit: AppInitService) {
  return () => appInit.init();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    ComponentsModule,
    BrowserAnimationsModule
  ],
  providers: [
    LocalStorage,
    SessionStorage,
    HttpHelpUtils,
    ReuseStrategyTab,
    HttpHelpUtilsWater,
    {
      provide: RouteReuseStrategy,
      useClass: CusRouteReuseStrategy,
      deps: [ReuseStrategyTab]
    }, 
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DefaultInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
